/** @module csi/widget/MaterialIconWithLink */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"dojo/text!./MaterialIconWithLink.html"
], function(declare,_WidgetBase,_TemplatedMixin,template) {
	
	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,
		
		/** @property {string} icon - name of material icon */
		icon: "",
		
		/** @property {string} href - link of material icon */
		href: "",

		/**
		 * Apply icon property to the text of icon node
		 */
		_setIconAttr: {node: "iconNode", type: "innerText"},

		/**
		 * Apply href property to the value of root node
		 */
		_setHrefAttr: {node: "domNode", type: "attribute"}
	});
});